import { render, staticRenderFns } from "./CataloguesCard.vue?vue&type=template&id=56f896ec&scoped=true"
import script from "./CataloguesCard.vue?vue&type=script&lang=js"
export * from "./CataloguesCard.vue?vue&type=script&lang=js"
import style0 from "./CataloguesCard.vue?vue&type=style&index=0&id=56f896ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f896ec",
  null
  
)

export default component.exports